import { useState } from "react";
import UIService from "../../../services/UIService";
import ChevronToggle from "../ChevronToggle/ChevronToggle";
import OwTitle from "../OwTitle/OwTitle";

type Props = {
    children: any;
    onToggleVisibleFn?: (isVisible: boolean) => void;
};

export const SearchSection = (props: Props) => {
    const [isVisible, setIsVisible] = useState(true);

    let cardClass = "dark-card text-white bg-secondary";

    if (UIService.isMainViewLight()) {
        cardClass = "";
    }

    const toggleVisible = () => {
        if (props.onToggleVisibleFn) {
            props.onToggleVisibleFn(!isVisible);
        }

        setIsVisible(!isVisible);
    };

    return (
        <div className="SearchSection row">
            <div className="col-12">
                <div className={"card w-100 rounded-bottom-0 " + cardClass}>
                    <div className={"card-body d-flex align-items-center pointer p-0 ps-2 "} onClick={toggleVisible}>
                        <ChevronToggle className={"d-inline-flex me-3 text-primary"} toggleFn={() => {}} isVisible={isVisible} />
                        <OwTitle title={"search"} tag={"h5"} className={"d-print-none"} leftIconName={"fad fa-search"} />
                    </div>
                </div>
            </div>

            <div className={"col-12 " + (isVisible ? "" : "d-none")}>
                <div className={"card rounded-top-0 " + cardClass}>
                    <div className="card-body">{props.children}</div>
                </div>
            </div>
        </div>
    );
};
